import { Component, computed, inject } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { BillingFacade } from '../../store/billing.facade';

@Component({
  selector: 'app-billing-status-banner',
  standalone: true,
  imports: [LucideAngularModule],
  template: `
    @if (message(); as msg) {
      <aside class="status-banner" role="status">
        <lucide-icon name="info" [size]="16" aria-hidden="true"></lucide-icon>
        <span>{{ msg }}</span>
      </aside>
    }
  `,
  styles: [
    `
      :host { display: block; position: sticky; top: 0; z-index: 24; }

      .status-banner {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px 18px;
        font-size: 13px;
        font-weight: 500;
        background: color-mix(in srgb, #f59e0b 16%, #fff);
        color: #92400e;
        border-bottom: 1px solid color-mix(in srgb, #f59e0b 32%, transparent);
      }

      .status-banner lucide-icon {
        flex-shrink: 0;
      }
    `,
  ],
})
export class StatusMessageBannerComponent {
  private readonly facade = inject(BillingFacade);

  readonly message = computed(() => {
    const value = this.facade.statusMessage();
    return value && value.trim() ? value.trim() : null;
  });
}
